export const RouteIds = {
  PAGES_PRODUCT: "pages/product",
  PAGES_PRODUCT_CLOSEOUT: "pages/product-closeout",
  PAGES_ORDER_STATUS: "pages/order-status",
  PAGES_ORDER_ACCOUNT: "pages/account-order",
} as const;
